// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"c811b242","189":"8ec6b393","756":"1b77460a","922":"aba8a958"}[chunkId] + ".chunk.js";
};